
import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { CommonModule, DatePipe, NgSwitch } from '@angular/common';
import { MatPaginator, MatSort, PageEvent } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs/Subject';

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/filter';

import { GlobalsPaths } from '../../../app.config';
import { APIsettings } from '../../../app.config';

import { VehiclesFilesService } from '../../../_services/vehicles-files.service';
import { VehiclesService } from '../../../_services/vehicles.service';
import { ToasterErrorService } from '../../../_services/toaster.service';
import * as moment from 'moment';

import { VehicleFileDataSource } from '../../../_datasources/vehicle-file.datasource';

import { IVehicleActivityApiParams, IVehicleActivityRow, IVehicleFileForm, VehicleActivityTypes } from 'app/_models/vehicle-file';
import { IScheduleType } from 'app/_models/schedule-activity';
import { IPaginatedVehicleResponse, SimpleVehicleFmt, Vehicle, VehicleListObj } from '../../../_models/vehicle';
import { timePrefsOffset } from '../../../Administration/User-preference/timezones.constants';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operator/debounceTime';
import { PaginationParams } from 'app/_models/generic';
import { finalize, tap, switchMap } from 'rxjs/operators';
import { MilePipe } from 'app/_pipes/distance/mile.pipe';
import { collapseTextChangeRangesAcrossMultipleVersions } from 'typescript';
import { AuthenticationService } from 'app/_services';

@Component({
    moduleId: module.id,
    selector: 'activity-app',
    templateUrl: `./activity.html`,
    styleUrls: ['./activity.component.scss']
})


export class ActivityComponent implements OnInit, OnDestroy {
    toasterconfig: any = this.toasterErrorService.toasterconfig;
    // Math: any; // used for template access to js Math library
    isLoading: boolean = true;
    // isFetchingTraceData: boolean = false;
    sidemenuOpen: boolean = true;
    img: string = this.globalsPaths.img;
    dateTimeFormat: string = this.apiSettings.apiDateTimeFormat;

    startDateTime: Date;
    endDateTime: Date;
    vehicleId: number;
    imageBase64: string | ArrayBuffer;
    imageFilename: string = 'Select a file...';
    vehicleName: string;
    vehicleType: string;
    selectedActivityType: number;
    selectedDepot: number;
    public showAuditTrail = false;
    public showArchived = false;
    public showUseActivityFulfilled = true;
    public showPendingInvestigations = false;

    vehicleActivityTypeList: Array<VehicleActivityTypes>;
    sidePanelvehicleActivityTypeList: Array<VehicleActivityTypes>;

    userPerm: any = JSON.parse(localStorage.getItem('userPerm')).perms;

    urlParaSub: any;
    hasTraceParamsInUrl: boolean = false;
    urlPassedVehicleObj: VehicleListObj = null;
    firstLoad: boolean = true;
    today = new Date().toISOString();

    public newVehicleFileForm: FormGroup; // our model driven form
    public filteredVehicles: Vehicle[] = [];


    selectedRowIndex: number;
    selectedRowForDetails: any = null;
    investigationsData: any[] = [];
    isLoadingInvestigations: boolean = false;
    dataSource: VehicleFileDataSource;
    displayedColumns: string[] = ['created_at', 'registration', 'description', 'activity_type', 'status', 'created_by', 'document', 'actions'];
    public defaultPageSize: number = 75;
    public pageDisplayOptions: Array<number> = [25, 50, 75];

    private pageSize = this.defaultPageSize;
    private pageCurrent = 0;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('sidenavCust') public sidenavCust;
    @ViewChild('detailsSidenav') public detailsSidenav;
    @ViewChild('imageUpload') imageUpload: ElementRef;

    componentDestroyed$: Subject<boolean> = new Subject();
    activitySchedule: IScheduleType;
    resetVehicleAutocomplete: boolean = false;
    imageUplaodError: string;
    isDownloadingPdf: boolean;
    datePromptMessage: string;
    userHasConfirmedFulfilledDate: boolean = true;
    showDatePromptMessage: boolean;


    get formActivityType() { return this.newVehicleFileForm.get('activity_type').value; }

    public vehicleActivityStatusList = [{ id: 1, name: 'Pass', do_not_create_schedule_activities: false }, { id: 2, name: 'Fail', do_not_create_schedule_activities: true }];
    private vehicleStatusListDefaults = [{ id: 1, name: 'Pass', do_not_create_schedule_activities: false }, { id: 2, name: 'Fail', do_not_create_schedule_activities: true }];

    // User to change the form if a user wants to manually upload a Saftey Inspection Vehicle file.
    // Uploading a manual Safety Inspection will set scedules activities for the vehicle based on the schedule type
    public isSafetyInspectionManualUpload: boolean = false;
    public activityFulfilledAtDateMessage: string = '';

    constructor(private router: Router,
        private _fb: FormBuilder,
        private datePipe: DatePipe,
        private globalsPaths: GlobalsPaths,
        private elementRef: ElementRef,
        private vehicleFileService: VehiclesFilesService,
        private apiSettings: APIsettings,
        private toasterErrorService: ToasterErrorService,
        private vehicleService: VehiclesService,
        private vehiclesFilesService: VehiclesFilesService,
        private route: ActivatedRoute,
        private authService: AuthenticationService) {
    }


    ngOnInit() {

        if (this.userPerm.is_limited_user == true) {
            this.router.navigate(['/home']);
        }

        // Get the vehicle activities
        this.getSidePanelVehicleActivityTypes();

        // Create new instance of datasource
        this.dataSource = new VehicleFileDataSource(this.vehicleFileService);

        // Initialize the formBuilder formGroup
        this.newVehicleFileForm = this._fb.group({
            activity_type: [null, Validators.compose([Validators.required])],
            vehicle: [null, Validators.compose([Validators.required])],
            description: [null, Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(90)])],
            document: [null],
            activity_fulfilled_at: [null],
            status: [null]
        });
        const _paginationParams: PaginationParams = { pageSize: 15, page: 1, orderingDirection: '-', ordering: 'registration', search: '' };

        // listen to activity_fulfilled_at form changes
        this.newVehicleFileForm.get("activity_fulfilled_at").valueChanges.subscribe(x => {
            if (x) {
                const _today = moment();
                const _sixMonthsAgo = _today.subtract(6, 'months');
                this.activityFulfilledAtDateMessage = x < _sixMonthsAgo ? 'The manual upload date is more than 6 months in the past. Are you sure the date is correct?' : '';

                // Prompt the user to confirm the date
                this.userHasConfirmedFulfilledDate = false;
                this.showDatePromptMessage = true;
                this.datePromptMessage = `Are you sure you want to create this vehicle file item with a date of: ${moment(x).format('DD/MM/YYYY')}?`;
            }

        })
    }



    public pageChange(e: PageEvent) {
        this.pageCurrent = e.pageIndex;
        this.pageSize = e.pageSize;
        this.loadVehicleActivityPage(true);
    }

    // Start of autocomplete methods
    public clearVehicle() {
        this.newVehicleFileForm.get('vehicle').setValue(null);
        this.newVehicleFileForm.get('activity_type').setValue(null);
    }
    public selectAFilteredVehicle(event) {
        if (event == null) {
            this.clearVehicle();
        } else {
            const _selectedVehicle: SimpleVehicleFmt = event;
            const _vehicleType = _selectedVehicle.vehicle_type ? _selectedVehicle.vehicle_type : null;
            this.newVehicleFileForm.get('vehicle').setValue(_selectedVehicle);
            this.getSidePanelVehicleActivityTypes(_vehicleType);
        }
    }
    displayFn(vehicle: Vehicle) {
        if (vehicle) { return vehicle.registration; }
    }
    // End of autocomplete

    public getIconUrl(vehicleTypeRef: string): string {
        if (vehicleTypeRef) {
            return `${this.img}icons/${vehicleTypeRef.toLowerCase()}-icon.svg`;
        } else {
            return '-'
        }
    }
    public getStatus(status, activity_type) {
        if (activity_type === "DEFECT") {
            const _status = String(status);
            if (_status === "178956970" || _status === "178956970_IS_VOR") return "Voided";
            if (_status === "357913941" || _status === "357913941_IS_VOR") return "Partial Non Verified";
            if (_status === "715827882" || _status === "715827882_IS_VOR") return "Verified Signed Off";
            if (_status === "715827888") return "Vehicle changed by manager";
            if (_status === "1431655764" || _status === "1431655764_IS_VOR") return "Repairer Name";
            if (_status === "1610612734" || _status === "1610612734_IS_VOR") return "Signed Off Roadworthy";
            if (_status === "1521134249") return "Repaired";
            if (_status === "1789569705") return "Complete";
        } else if (activity_type === "SAFETY_INSPECTION") {
            const _status = Number(status);
            if (_status === 1) return "Cancelled";
            if (_status === 3) return "Incomplete";
            if (_status === 5) return "Complete - Pending Team Leader Review";
            if (_status === 6) return "Team Leader Review - Rejected";
            if (_status === 7) return "Complete";
            if (_status === 11) return "Complete - Internal QC Review"; // Should be 'Complete - Internal QC review' - SC wanted to be complete for rejected
            if (_status === 12) return "Complete - QC Done";
        } else if (status) {
            return status;
        }
        return "No status";
    };

    openAddNewVehicleFile() {
        this.resetVehicleAutocomplete = false;
        this.sidenavCust.open();
    }

    openDetailsSidebar(row: any) {
        this.selectedRowForDetails = row;
        this.detailsSidenav.open();
        // Load investigations for this activity
        if (row.id) {
            this.loadInvestigations(row.id);
        }
    }

    closeDetailsSidebar() {
        this.selectedRowForDetails = null;
        this.detailsSidenav.close();
    }

    viewInvestigationDetails(investigation: any) {
        // Navigate to investigation details page with nested route structure
        this.router.navigate(['/vehicle-file/activity', this.selectedRowForDetails.id, 'investigation', investigation.id]);
    }

    private renameFile(originalFile, newName) {
        return new File([originalFile], newName, {
            type: originalFile.type,
            lastModified: originalFile.lastModified,
        });
    }
    onImageSelect(eve) {
        this.imageUplaodError = '';
        let file = eve.target.files[0];
        if (file && file.size < 9000000) {
            const reg = this.newVehicleFileForm.get('vehicle').value ? `_${this.newVehicleFileForm.get('vehicle').value['registration']}` : '';
            const strippedReg = reg.replace(/\s+/g, '');
            const actType = this.newVehicleFileForm.get('activity_type');
            const filenameSuffix = actType ? `_${actType.value['reference']}` : '';
            const date = `_${this.datePipe.transform(Date.now(), 'dd-MM-yyyyTHH:mm:ss')}`;
            // Set the custom filename
            const filename = file.name.split('.').slice(0, -1).join('.');
            const extension = file.name.split('.').pop();
            let fullFilename = filename + `${strippedReg}${filenameSuffix}${date}.${extension}`;
            const filenameMaxLen = 90;
            // There is a max length on google storages of 90-94 characters
            if (fullFilename.length > filenameMaxLen) {
                const len = fullFilename.length;
                fullFilename = fullFilename.slice(len - filenameMaxLen);
            }

            this.imageFilename = fullFilename;
            const newFile = this.renameFile(file, fullFilename); // Need to recreate te file with the new filename

            this.newVehicleFileForm.patchValue({ document: newFile })
            if (file.type !== 'application/pdf') {
                const reader = new FileReader();
                reader.onload = () => this.imageBase64 = reader.result;
                reader.onerror = error => this.imageBase64 = null;
                reader.readAsDataURL(file);
            } else {
                this.imageBase64 = null
            }
        } else {
            this.imageUplaodError = 'Image is too large to upload (Upload a doc less than 9mb)';
        }


    }
    public clearPreviewImage() {
        this.imageFilename = null;
        this.imageBase64 = null;
        if (this.imageUpload) {
            this.imageUpload.nativeElement.value = '';
        }
        this.newVehicleFileForm.patchValue({ document: null });
    }

    private getSidePanelVehicleActivityTypes(vehicleTypeFilter?: string) {
        // Reset the formgroup and local selected schedule
        this.activitySchedule = null;
        if (this.newVehicleFileForm) {
            this.newVehicleFileForm.patchValue({ activity_type: null });
        }

        // Get Vehicle Activities types for vehicle
        this.vehiclesFilesService.getVehicleActivityTypes(vehicleTypeFilter, true).subscribe((data) => {
            this.sidePanelvehicleActivityTypeList = data;
        })
    }


    private getScheduleActivityType(id: number) {
        this.vehiclesFilesService.getScheduleType(id).subscribe((data) => {
            this.activitySchedule = data;
            const intervals: string[] = data.interval.split(' ');

            const _now = moment();
            let _scheduleDueDate = _now;
            for (let index = 0; index < intervals.length; index++) {
                const element = intervals[index];
                const intervalUnit = element.substr(-1);
                let intervalValue = element.slice(0, -1);
                let _unit: any;
                switch (intervalUnit) {
                    case "y":
                        _unit = "years";
                        break;
                    case "m":
                        _unit = "months";
                        break;
                    case "w":
                        _unit = "weeks";
                        break;
                    case "d":
                        _unit = "days";
                        break;
                    case "h":
                        _unit = "hours";
                        break;
                    default:
                        // this is 'min' - minutes
                        _unit = "minutes";
                }
                if (_unit === 'minutes') {
                    // this will get the correct value as minutes is in 'min'
                    intervalValue = element.slice(0, -3);
                }
                _scheduleDueDate.add(intervalValue, _unit);

            }
            this.activitySchedule['due_date'] = _scheduleDueDate;
            this.activitySchedule['time_until'] = _scheduleDueDate.fromNow();
            this.activityFulfilledAtDateMessage = '';
        });
    }

    public selectActivityType(event) {
        // Resets the schedule for the activity when being changed by the user
        this.activitySchedule = null;
        this.loadActivityStatus(event.value.reference);

        if (event.value.schedule_type) {
            this.getScheduleActivityType(event.value.schedule_type);
        }
        if (event.value.reference == 'SAFETY_INSPECTION') {
            // This is now going to be a Manual Safety Inspection
            // Set status to the 7 which is the status id on Completed
            this.isSafetyInspectionManualUpload = true;
            this.newVehicleFileForm.patchValue({
                description: 'Manual Safety Inspection for ' + this.newVehicleFileForm.get('vehicle').value.registration,
                status: 'Completed'
            });
            this.newVehicleFileForm.get('description').disable();

        } else {
            this.isSafetyInspectionManualUpload = false;
            this.newVehicleFileForm.patchValue({
                description: '',
            });
            this.newVehicleFileForm.get('description').enable();
        }
        if (event.value.require_user_date_input) {
            // Set default fullfill date to today
            this.newVehicleFileForm.patchValue({
                activity_fulfilled_at: moment().format(),
            });
        } else {
            // if a user date isntt required set userHasConfirmedFulfilledDate to true to enable send buttton
            this.userHasConfirmedFulfilledDate = true;
        }
    }

    loadActivityStatus(reference: string) {
        if (this.newVehicleFileForm.get('activity_type').value.use_activity_statuses_on_ui) {
            this.vehicleFileService.getSingleVehicleActivityTypes(this.newVehicleFileForm.get('activity_type').value.id).subscribe((e) => {
                console.log(e);
                this.vehicleActivityStatusList = e.statuses;
            });
        } else {
            if (reference == 'MOT') {
                this.vehicleActivityStatusList = [...this.vehicleStatusListDefaults, { id: 3, name: 'PRS', do_not_create_schedule_activities: true }]
            } else if (reference == 'PMI_FORM') {
                const pmiStatus = { id: 1, name: 'Completed', do_not_create_schedule_activities: true }
                this.newVehicleFileForm.patchValue({
                    status: pmiStatus
                });
            } else {
                // Reset the status drop down
                this.vehicleActivityStatusList = [...this.vehicleStatusListDefaults];
            }
        }
    }

    public answerFulfilledDateConfirmation(answer: boolean) {
        this.userHasConfirmedFulfilledDate = answer;
        this.showDatePromptMessage = false;
        this.datePromptMessage = '';

    }

    public sendFormVehicleFile(formData) {
        if (this.newVehicleFileForm.valid) {

            // Validation rule - if a new activity has a Schedule assigned to it then it must have a document uploaded
            const hasDocument = this.newVehicleFileForm.get('document').value;
            if (!!this.activitySchedule && !hasDocument) {
                this.toasterErrorService.toasterErr('An image is required to submit this document.');
                return;
            }

            let _param = null;
            let _createSchedule = false;
            this.isLoading = true;
            const registration = this.newVehicleFileForm.get('vehicle').value.registration
            if (formData.activity_type.schedule_type) {
                _createSchedule = true;
            } else {
                formData.activity_type = formData.activity_type.reference;
            }

            formData.vehicle = formData.vehicle.id;


            let fufillThisActivity = true;

            if (formData.status) {
                fufillThisActivity = !formData.status.do_not_create_schedule_activities;
                formData.status = formData.status.name;
            }
            if (formData.activity_fulfilled_at) {
                // Set the date to be start of the day all the time regardless of timezone
                const datestring = moment(formData.activity_fulfilled_at).format().split('T');
                formData.activity_fulfilled_at = datestring[0] + 'T00:00:00Z';
            }

            if (formData.activity_type.reference !== 'SAFETY_INSPECTION') {
                this.vehicleFileService.postVehicleActivities(formData, _createSchedule, fufillThisActivity)
                    .subscribe(
                        successData => {
                            this.isLoading = false;
                            this.toasterErrorService.toasterSuccess('Document created in vehicle file');
                            this.resetNewActivityForm();
                            this.sidenavCust.close();
                            this.loadVehicleActivityPage();
                            this.checkUnqualifiedToApproveSchedulesMessage(successData['unqualified_to_approve_schedules']);
                        },
                        errData => {
                            this.isLoading = false;
                            if (errData.status === 403) {
                                this.toasterErrorService.openToaster(errData._body);
                            } else {
                                this.toasterErrorService.toasterInvalidField();
                            }
                        }
                    );
            }
            else {
                this.vehicleFileService.postManualSafetyInspection(formData, _createSchedule, registration)
                    .subscribe(
                        successData => {
                            this.isLoading = false;
                            this.toasterErrorService.toasterSuccess('Safety Inspection created in vehicle file');
                            this.sidenavClose();
                            this.loadVehicleActivityPage();
                            this.checkUnqualifiedToApproveSchedulesMessage(successData['unqualified_to_approve_schedules']);
                        },
                        errData => {
                            this.isLoading = false;
                            if (errData.status === 403) {
                                this.toasterErrorService.openToaster(errData._body);
                            } else {
                                this.toasterErrorService.toasterInvalidField();
                            }
                        }
                    );
            }

        }
    }

    private checkUnqualifiedToApproveSchedulesMessage(unqualified_to_approve_schedules: boolean) {
        //  
        if (unqualified_to_approve_schedules) {
            const title = 'No Schedules Created';
            const message = 'The item was saved to Vehicle File, but there were no schedules created as this vehicle has more recent scheduled activities already set.'
            setTimeout(() => {
                this.toasterErrorService.toastWarningVehicleFile(title, message);
            }, 2500);

        }
    }

    private resetNewActivityForm() {
        this.newVehicleFileForm.reset();
        this.resetVehicleAutocomplete = true;
        this.activitySchedule = null;
        this.clearPreviewImage();
        this.activityFulfilledAtDateMessage = '';
        this.datePromptMessage = '';
    }

    public sidenavClose() {
        this.resetNewActivityForm();
        this.sidenavCust.close();
    }

    private loadVehicleActivityPage(changingPage?: boolean) {
        let dateRange = null;
        if (this.startDateTime && this.endDateTime) {
            dateRange = `${moment(this.startDateTime.toISOString()).format('DD-MM-YYYY')
                },${moment(this.endDateTime.toISOString()).format('DD-MM-YYYY')
                }`;

        }
        if (!changingPage) {
            this.pageCurrent = 0;
        }


        if (this.showUseActivityFulfilled === true) {
            const _params: IVehicleActivityApiParams = {
                vehicle: this.vehicleId,
                fulfilled_at_date_range: dateRange,
                depot: this.selectedDepot,
                region: null,
                activity_type: this.selectedActivityType == 0 ? null : this.selectedActivityType,
                filter_latest: this.showAuditTrail ? null : 'True',
                page: this.pageCurrent + 1,
                pageSize: this.pageSize,
                ordering: this.showUseActivityFulfilled ? '' : '-created_at',
                archived: this.showArchived ? 'true' : null,
                has_pending_investigations: this.showPendingInvestigations ? true : undefined
            };
            this.dataSource.loadVehicleActivities(_params);
        } else {
            const _params: IVehicleActivityApiParams = {
                vehicle: this.vehicleId,
                date_range: dateRange,
                depot: this.selectedDepot,
                region: null,
                activity_type: this.selectedActivityType == 0 ? null : this.selectedActivityType,
                filter_latest: this.showAuditTrail ? null : 'True',
                page: this.pageCurrent + 1,
                pageSize: this.pageSize,
                ordering: '-created_at',
                archived: this.showArchived ? 'true' : null,
                has_pending_investigations: this.showPendingInvestigations ? true : undefined
            };
            this.dataSource.loadVehicleActivities(_params);
        }

        // this.dataSource.loadVehicleActivities(_params);
    }

    private loadInvestigations(activityId: number) {
        this.isLoadingInvestigations = true;
        this.investigationsData = [];
        
        this.vehicleFileService.getVehicleActivityInvestigations(activityId).subscribe(
            (data) => {
                this.investigationsData = data.results || [];
                this.isLoadingInvestigations = false;
            },
            (error) => {
                console.error('Error loading investigations:', error);
                this.investigationsData = [];
                this.isLoadingInvestigations = false;
                this.toasterErrorService.toasterErr('Failed to load investigations');
            }
        );
    }

    public downloadDefectPdfLink(id: number, reg: string) {
        this.isLoading = true;

        this.authService.fetchJwtTokenFromBearer().then((data) => {
            console.log('downloadDefectPdfLink JWT Token from bearer: ', data);
            if (data) {
                this.vehicleFileService.postDefectReportPdf(id, data.token).subscribe((data) => {
                    this.downloadFileResponse(data._body, `defect-report_${reg}`);
                    this.isLoading = false;
                }, err => {
                    this.isLoading = false;
                    this.toasterErrorService.toasterErr('Something when wrong with the PDF download');
                });
            } else {
                console.log('JWT token undefined');
                this.isLoading = false;
            }



        }, err => {

            this.toasterErrorService.toasterErr('Something when wrong with the translating token');
        });
    }

    // public downloadSIPdfLink(id: number, reg: string) {
    //     this.isLoading = true;
    //     this.vehicleFileService.getSafetyInspectionReportPdf(id).subscribe((data) => {
    //         this.downloadFileResponse(data, `safety-inspection-report_${id}_${reg}`);
    //         this.isLoading = false;
    //     }, err => {
    //         this.isLoading = false;
    //         this.toasterErrorService.toasterErr('Something when wrong with the PDF download');
    //     });

    // }
    public downloadSIPdfLink(id: number, reg: string) {
        this.isLoading = true;
        const authenticated = this.authService.getAuthCookie();
        this.vehicleFileService.getSafetyInspectionReportPdf(id, authenticated).subscribe((data) => {
            this.downloadFileResponse(data, `safety-inspection-report_${id}_${reg}`);
            this.isLoading = false;
        }, err => {
            this.isLoading = false;
            this.toasterErrorService.toasterErr('Something when wrong with the PDF download');
        });
       
    }

    private downloadFileResponse(response, filename?: string) {
        // Reusable PDF convert download link
        const _filename = filename ? `${filename}.pdf` : 'datalive-download.pdf';
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, _filename);
            navigator.msSaveBlob(blob);
        } else {
            const a = document.createElement('a');
            a.href = url;
            a.download = _filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
        window.URL.revokeObjectURL(url);
    }

    private downloadFile(data, fileName) {

        const blob = new Blob([data], { type: 'text/csv' });
        saveAs(blob, fileName);
        // const url = window.URL.createObjectURL(blob);
        // console.log('Report url: ', url);
        // window.open(url);
    }

    ngOnDestroy() {
        this.componentDestroyed$.next(true);
        this.componentDestroyed$.complete();
    }

    // This is the function being called by the vehicle file sidebar output
    loadActivities() {
        this.loadVehicleActivityPage();
    }


}





// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/Vehicle-file/components/Activity/activity.component.ts